/* eslint-disable */
export default {
  loginButton: 'Accedi',
  signupButton: 'Nuovo utente? Registrati',
  version: 'Versione',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
